import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { FarmApiService } from 'src/app/core/api/farm-api.service';
import { CalendarPickerModalComponent } from 'src/app/core/helper/components/calendar-picker-modal/calendar-picker-modal.component';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { DateFormats } from 'src/app/core/models/enums/date-formats';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { CropResponse } from 'src/app/core/models/interfaces/crop-response';
import { IFarmSaveModel } from 'src/app/core/models/interfaces/farm-save-model';
import { IListModalModel } from 'src/app/core/models/interfaces/list-modal-component-model';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { DoktarConstantsService } from 'src/app/core/services/doktar-constants.service';
import { LanguageService } from 'src/app/core/services/lang.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { FarmDeviceDetailItem } from '../../models/farm-device.model';

@Component({
  selector: 'app-farm-edit',
  templateUrl: './farm-edit.component.html',
  styleUrls: ['./farm-edit.component.scss'],
})
export class FarmEditComponent extends BaseModal implements OnInit {
  @Input() detailItem: FarmDeviceDetailItem;
  isFiliz: any;
  type: string;
  cropVarietyListOpen: boolean = true;
  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private farmApi: FarmApiService,
    private dateTimeService: DateTimeService,
    private doktarConstantService: DoktarConstantsService,
    private langService: LanguageService,
    private modalService: ModalService,
    private storageService: StorageService,
    private toastService: ToastService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute) {
    super()
    super._modalService = modalService
  }
  farmSaveForm: FormGroup = new FormGroup({});
  ngOnInit() {
    super.ngOnInit();
    this.setupForm();
  }

  ionViewDidEnter() {
    this.storageService.get(StorageKeys.FILIZ_MODE).then(e => {
      if (e.IsSuccess) {
        this.isFiliz = e.Data;
        if (this.isFiliz) {
          this.type = "filiz"
        } else {
          this.type = "trap"
        }
      }
    })
  }

  setupForm() {
    this.farmSaveForm = new FormGroup({
      "FarmName": new FormControl(this.detailItem?.FarmName, [Validators.required]),
      "CropId": new FormControl(this.detailItem?.CropId, [Validators.min(1), Validators.required]),
      "CropVarietyId": new FormControl(this.detailItem?.CropVarietyId ? this.detailItem?.CropVarietyId : -1, [Validators.required]),
      "SowingDate": new FormControl(this.detailItem?.SowingDate ? this.detailItem?.SowingDate : '1970-01-01', [Validators.required]),
      "HarvestDate": new FormControl(this.detailItem?.HarvestDate ? this.detailItem?.HarvestDate : '1970-01-01', [Validators.required]),
      "CropName": new FormControl(this.langService.getTranslation(`crops.${this.detailItem?.CropName}`)),
      "CropVarietyName": new FormControl((this.detailItem?.CropVarietyName == 'Genel' || this.detailItem?.CropVarietyName == 'Erkenci' || this.detailItem?.CropVarietyName == 'Geç') ? this.langService.getTranslation(`crop-variety.${this.detailItem?.CropVarietyName}`) : this.detailItem?.CropVarietyName),
      "SoilTypeId": new FormControl(this.detailItem ? this.detailItem?.SoilTypeId : null),
      "SoilTypeName": new FormControl(this.langService.getTranslation(`constants.${this.detailItem?.SoilTypeName}`)),
      "IrrigationTypeId": new FormControl(this.detailItem.IrrigationTypeId ? this.detailItem?.IrrigationTypeId : null),
      "IrrigationTypeName": new FormControl(this.langService.getTranslation(`constants.${this.detailItem?.IrrigationTypeName}`)),
      "FarmingMethodId": new FormControl(this.detailItem.FarmingMethodId ? this.detailItem?.FarmingMethodId : null),
      "FarmingMethodName": new FormControl(this.langService.getTranslation(`constants.${this.detailItem?.FarmingMethodName}`)),
      "ChillingStartDate": new FormControl(this.detailItem.ChillingStartDate ? this.detailItem?.ChillingStartDate : null),
      "ChillingEndDate": new FormControl(this.detailItem.ChillingEndDate ? this.detailItem?.ChillingEndDate : null)
    });


    if (this.isFiliz) {
      this.farmSaveForm.controls['SoilTypeId'].addValidators(Validators.required);
      this.farmSaveForm.controls['IrrigationTypeId'].addValidators(Validators.required);
    }
    this.getCropList().subscribe(e => {
      if (e) {
        this.selectedCrop = this.cropList.find(crop => crop.CropId == +this.farmSaveForm.controls["CropId"].value);
      }
    });
  }
  selectedCrop: CropResponse;
  cropList: Array<CropResponse> = [];
  getCropList(): Observable<boolean> {
    return new Observable(observer => {
      this.doktarConstantService.RequestCropList(false).subscribe(cropResponse => {
        if (cropResponse) {
          this.cropList = cropResponse;
          observer.next(true);
        }
      })
    });
  }
  presentCropModal() {
    this.loadingService.showLoading();
    this.getCropList().subscribe(res => {
      if (res) {
        let _tempSelectedCrop = this.farmSaveForm.controls["CropId"].value || -1
        let tempCropList: Array<IListModalModel> = this.cropList.map(t => {
          let _temp: IListModalModel = {
            id: t.CropId,
            key: t.CropName,
            value: this.langService.getTranslation(`crops.${t.CropName}`),
            isChecked: t.CropId == _tempSelectedCrop
          }
          return _temp
        })
        tempCropList.sort((objA, objB) => {
          let a: string = objA.value, b: string = objB.value;
          return a.localeCompare(b)
        })
        this.modalService.presentListModal({
          confirmBtnText: "",
          hasConfirmBtn: false,
          isMultiple: false,
          itemList: tempCropList,
          title: this.langService.getTranslation("general.crop_list_title"),
          isFullscreen: true,
          placeholder: this.translate.instant("general.search-crop")
        }, true).then(response => {
          this.loadingService.hideLoading();
          response.modalObj.onDidDismiss().then(response => {
            if (response.role === "itemSelected") {
              let tempCrop = response.data.selectedItem
              this.farmSaveForm.patchValue({ CropId: tempCrop.id }, { emitEvent: true, onlySelf: false })
              this.farmSaveForm.patchValue({ CropName: tempCrop.value }, { emitEvent: true, onlySelf: true })
              this.farmSaveForm.patchValue({ CropVarietyId: -1 }, { emitEvent: true, onlySelf: false })
              this.farmSaveForm.patchValue({ CropVarietyName: "" }, { emitEvent: true, onlySelf: false })
              this.farmSaveForm.controls.CropId.markAllAsTouched();
              this.farmSaveForm.controls.CropName.markAllAsTouched();
              this.selectedCrop = this.cropList.find(crop => crop.CropId == tempCrop.id);
              this.presentCropVarietyModal();
            }
          })
        })
      }
    })
  }


  presentIrrigationModal() {
    this.loadingService.showLoading();
    this.doktarConstantService.RequestIrrigationList().subscribe(irrigationResponse => {
      if (irrigationResponse) {
        let _tempSelectedIrrigation = this.farmSaveForm.controls["IrrigationTypeId"].value || -1
        let tempIrrigationList: Array<IListModalModel> = irrigationResponse.map(t => {
          let _temp: IListModalModel = {
            id: t.ConstantId,
            key: t.ConstantValue,
            value: this.langService.getTranslation(`constants.${t.ConstantValue}`),
            isChecked: t.ConstantId == _tempSelectedIrrigation
          }
          return _temp
        })
        tempIrrigationList.sort()
        this.modalService.presentListModal({
          confirmBtnText: "",
          hasConfirmBtn: false,
          isMultiple: false,
          itemList: tempIrrigationList,
          title: this.langService.getTranslation("general.irrigation_list_title"),
          isFullscreen: true
        }, true).then(response => {
          this.loadingService.hideLoading();
          response.modalObj.onDidDismiss().then(response => {
            if (response.role === "itemSelected") {
              let tempIrrigation = response.data.selectedItem
              this.farmSaveForm.patchValue({ IrrigationTypeId: tempIrrigation.id }, { emitEvent: true, onlySelf: false });
              this.farmSaveForm.patchValue({ IrrigationTypeName: tempIrrigation.value }, { emitEvent: true, onlySelf: true });
              this.farmSaveForm.controls.IrrigationTypeId.markAllAsTouched();
              this.farmSaveForm.controls.IrrigationTypeName.markAllAsTouched();
            }
          });
        });
      }
    });
  }

  presentFarmingMethod() {
    this.loadingService.showLoading();
    this.doktarConstantService.RequestFarmingMethod().subscribe(FarmingMethod => {
      if (FarmingMethod) {
        let _tempSelectedSoil = this.farmSaveForm.controls["FarmingMethodId"].value || -1
        let tempSoilList: Array<IListModalModel> = FarmingMethod.map(t => {
          let _temp: IListModalModel = {
            id: t.ConstantId,
            key: t.ConstantValue,
            value: this.langService.getTranslation(`constants.${t.ConstantValue}`),
            isChecked: t.ConstantId == _tempSelectedSoil
          }
          return _temp
        })
        tempSoilList.sort()
        this.modalService.presentListModal({
          confirmBtnText: "",
          hasConfirmBtn: false,
          isMultiple: false,
          itemList: tempSoilList,
          title: this.langService.getTranslation("add_field.farming_method"),
          isFullscreen: true
        }, true).then(response => {
          this.loadingService.hideLoading();
          response.modalObj.onDidDismiss().then(response => {
            if (response.role === "itemSelected") {
              let tempSoil = response.data.selectedItem
              this.farmSaveForm.patchValue({ FarmingMethodId: tempSoil.id }, { emitEvent: true, onlySelf: false });
              this.farmSaveForm.patchValue({ FarmingMethodName: tempSoil.value }, { emitEvent: true, onlySelf: true });
              this.farmSaveForm.controls.FarmingMethodId.markAllAsTouched()
              this.farmSaveForm.controls.FarmingMethodName.markAllAsTouched()
            }
          });
        });
      }
    })
  }


  presentSoilTypeModal() {
    this.loadingService.showLoading();
    this.doktarConstantService.RequestSoilList().subscribe(SoilResponse => {
      if (SoilResponse) {
        let _tempSelectedSoil = this.farmSaveForm.controls["SoilTypeId"].value || -1
        let tempSoilList: Array<IListModalModel> = SoilResponse.map(t => {
          let _temp: IListModalModel = {
            id: t.ConstantId,
            key: t.ConstantValue,
            value: this.langService.getTranslation(`constants.${t.ConstantValue}`),
            isChecked: t.ConstantId == _tempSelectedSoil
          }
          return _temp
        })
        tempSoilList.sort()
        this.modalService.presentListModal({
          confirmBtnText: "",
          hasConfirmBtn: false,
          isMultiple: false,
          itemList: tempSoilList,
          title: this.langService.getTranslation("general.soil_list_title"),
          isFullscreen: true
        }, true).then(response => {
          this.loadingService.hideLoading();
          response.modalObj.onDidDismiss().then(response => {
            if (response.role === "itemSelected") {
              let tempSoil = response.data.selectedItem
              this.farmSaveForm.patchValue({ SoilTypeId: tempSoil.id }, { emitEvent: true, onlySelf: false });
              this.farmSaveForm.patchValue({ SoilTypeName: tempSoil.value }, { emitEvent: true, onlySelf: true });
              this.farmSaveForm.controls.SoilTypeId.markAllAsTouched()
              this.farmSaveForm.controls.SoilTypeName.markAllAsTouched()
            }
          });
        });
      }
    })
  }

  presentCropVarietyModal() {
    let selectedCropId = this.farmSaveForm.controls["CropId"].value
    if (selectedCropId && selectedCropId > -1) {
      this.loadingService.showLoading();
      this.doktarConstantService.RequestCropVariety(selectedCropId).subscribe(cropResponse => {
        if (cropResponse && cropResponse.length > 1) {
          this.cropVarietyListOpen = true;
          let _tempSelectedCropVariety = this.farmSaveForm.controls["CropVarietyId"].value || -1
          let tempCropList: Array<IListModalModel> = cropResponse.map(t => {
            let _temp: IListModalModel = {
              id: t.CropVarietyId,
              key: t.CropVarietyName,
              value: ((t.CropVarietyName == 'Genel' || t.CropVarietyName == 'Erkenci' || t.CropVarietyName == 'Geç') ? this.translate.instant("crop-variety." + t.CropVarietyName) : t.CropVarietyName),
              isChecked: t.CropId == _tempSelectedCropVariety
            }
            return _temp
          });
          tempCropList.sort((objA, objB) => {
            let a: string = objA.value, b: string = objB.value;
            return a.localeCompare(b)
          })
          this.modalService.presentListModal({
            confirmBtnText: "",
            hasConfirmBtn: false,
            isMultiple: false,
            itemList: tempCropList,
            title: this.langService.getTranslation("general.crop-variety-list"),
            isFullscreen: true
          }, true).then(response => {
            this.loadingService.hideLoading();
            response.modalObj.onDidDismiss().then(response => {
              if (response.role === "itemSelected") {
                let tempCrop = response.data.selectedItem;
                this.farmSaveForm.patchValue({ CropVarietyId: tempCrop.id }, { emitEvent: true, onlySelf: false })
                this.farmSaveForm.patchValue({ CropVarietyName: (tempCrop.value == 'Genel' || tempCrop.value == 'Erkenci' || tempCrop.value == 'Geç') ? this.translate.instant('crop-variety.' + tempCrop.value) : tempCrop.value }, { emitEvent: true, onlySelf: false })
              }
            });
          });
        } else {
          this.loadingService.hideLoading();
          this.cropVarietyListOpen = false;
          this.farmSaveForm.patchValue({ CropVarietyId: cropResponse[0].CropVarietyId }, { emitEvent: true, onlySelf: false });
          this.farmSaveForm.patchValue({ CropVarietyName: this.translate.instant('crop-variety.' + cropResponse[0].CropVarietyName) }, { emitEvent: true, onlySelf: false })
        }
      })
    } else {
      this.farmSaveForm.patchValue({ CropVarietyId: -1 }, { emitEvent: true, onlySelf: true });
    }
    this.farmSaveForm.controls.CropVarietyId.markAllAsTouched();
    this.farmSaveForm.controls.CropVarietyName.markAllAsTouched();
  }
  // openDateTime(type) {
  //   let date
  //   if (type == "HarvestDate") {
  //     date = this.farmSaveForm.controls["HarvestDate"].value;
  //   } else if (type == "SowingDate") {
  //     date = this.farmSaveForm.controls["SowingDate"].value;
  //   }
  //   this.modalService.presentModal({
  //     component: CalendarPickerModalComponent,
  //     componentProps: {
  //       title: this.langService.getTranslation("add_field.sowing_date"),
  //       selectedDate: date
  //     },
  //     options: ModalService.defaultOptions
  //   }).then(response => {

  //     response.modalObj.onDidDismiss().then(dismiss => {
  //       if (dismiss.role == "selected") {
  //         let patchValue = {}
  //         patchValue[type] = dismiss.data.date
  //         this.farmSaveForm.patchValue(patchValue, { onlySelf: true, emitEvent: true });
  //       }
  //     })
  //   })
  // }
  openDateTime(type) {
    let date, title
    if (type == "HarvestDate") {
      date = this.farmSaveForm.controls["HarvestDate"].value;
      title = this.langService.getTranslation("constants." + this.selectedCrop.CropHarvestName)
    } else if (type == "SowingDate") {
      date = this.farmSaveForm.controls["SowingDate"].value;
      title = this.langService.getTranslation("constants." + this.selectedCrop.CropSowingName)
    }
    this.modalService.openCalendarModal({

      title: title,
      preSelected: date,
      startDate: date,
      min: null,
      max: null,
      isBottomSheet: true,
      options: ModalService.defaultOptions
    }).subscribe(response => {
      let patchValue = {}
      patchValue[type] = response.date
      this.farmSaveForm.patchValue(patchValue, { onlySelf: true, emitEvent: true });
    })
  }

  saveFarm() {
    this.loadingService.showLoading();
    let controls = this.farmSaveForm.controls;
    let payload: IFarmSaveModel = {
      CalculatedArea: this.detailItem.CalculatedArea,
      CropId: controls.CropId.value,
      CropVarietyId: this.detailItem.CropVarietyId ? this.detailItem.CropVarietyId : -1,
      FarmName: controls.FarmName.value,
      GeoJson: this.detailItem.Location,
      HarvestDate: this.detailItem?.HarvestDate ? this.detailItem.HarvestDate : "1970-01-01",
      SowingDate: this.detailItem?.SowingDate ? this.detailItem.SowingDate : "1970-01-01",
      TempFarmAttId: this.detailItem.TempFarmAttId,
      IrrigationTypeId: this.detailItem.IrrigationTypeId ? this.detailItem.IrrigationTypeId : null,
      SensorId: this.detailItem.SensorId,
      SoilTypeId: this.detailItem.SoilTypeId ? this.detailItem.SoilTypeId : null,
      FarmingMethodId: this.detailItem.FarmingMethodId ? this.detailItem.FarmingMethodId : null,
      PhId: 44,
      ChillingEndDate: this.detailItem.ChillingEndDate ? this.detailItem.ChillingEndDate : null,
      ChillingStartDate: this.detailItem.ChillingStartDate ? this.detailItem.ChillingStartDate : null
    }
    this.farmApi.FarmSave(payload, this.type).subscribe(farmResponse => {
      if (farmResponse && farmResponse.IsSuccess) {
        this.storageService.lastFilizFarmId = null;
        this.storageService.lastTrapFarmId = null;
        this.storageService.set(StorageKeys.updated, true).then();
        this.storageService.set(StorageKeys.mapUpdated, true).then();
        this.modalService.dismissByModalId(this.id, null, "success");
        this.router.navigate(["/common/detail"], {
          queryParams: {
            sensorType: this.activatedRoute.snapshot.queryParams.sensorType,
            farmId: this.detailItem.TempFarmAttId
          },
          replaceUrl: true
        });
      }
      this.loadingService.hideLoading()
    }, err => {
      this.loadingService.hideLoading()
    }, () => {
      this.loadingService.hideLoading()
    })

  }
}
